import React, { useEffect, useRef, useState } from 'react'
import ReportsModalStyle from './ReportsModalStyle'
import Modal from 'react-modal'
import { get } from 'lodash'
import { customFuncsApi } from '../../../api'
import api from '../../../api'
import { useSelector } from 'react-redux'
import customMainApi from '../../../api'
import { ErrorModal, SuccessModal } from '../index'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { Button as AntButton } from 'antd'
const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		borderRadius: 15,
		border: 'none',
		overflowX: 'auto',
		...(window.innerWidth <= 640 ? { height: '90%' } : {}),
	},
	overlay: {
		background: '#00000099',
	},
}
const PurchaseReturnsModal = ({
	getRef = () => {},
	onConfirm = () => {},
	onClose = () => {},
	isLoading = false,
	onUpdated = () => {},
}) => {
	const { getMe } = useSelector((state) => state.main)
	const { t } = useTranslation()

	const errorModalRef = useRef()
	const successModalRef = useRef()

	const [isOpenModal, setIsOpenModal] = useState(false)
	const [loading, setLoading] = useState(false)
	const [userFields, setUserFields] = useState([])
	const [date, setDate] = useState(moment().format('YYYY-MM-DD'))
	const [item, setItem] = useState('')
	const [price, setPrice] = useState('')
	const [debt, setDebt] = useState('')
	const [docEntry, setDocEntry] = useState('')
	const [status, setStatus] = useState('bosh')
	const [userFields2, setUserFields2] = useState([])
	const [cashAcc, setCashAcc] = useState('')
	const [cashAccountsData, setCashAccountsData] = useState([])

	useEffect(() => {
		const ref = {
			open: (data) => {
				setIsOpenModal(true)

				setDocEntry(
					get(data, 'DocEntry', null) !== null ? get(data, 'DocEntry', '') : '',
				)
				setItem(
					get(data, 'Dscription', null) !== null
						? get(data, 'Dscription', '')
						: '',
				)
			},
			close: () => setIsOpenModal(false),
		}
		getRef(ref)
	}, [])

	const submit = async () => {
		setLoading(true)
		try {
			await customFuncsApi.post('addItemReturnFromDebtor', {
				DocDate: date,
				invoiceDocEntry: docEntry,
				itemPrice: price,
				U_CashFlow: 'Vozvrat',
				'Security.U_Status': status,
				SalesPersonCode: getMe.SalesPersonCode || -1,
				account: cashAcc,
				CashAccount: getMe?.U_CashAccount,
			})
			setTimeout(() => {
				onConfirm()
				onUpdated()
				setIsOpenModal(false)
			}, 2000)
			successModalRef.current?.open(t('returnSuccess'))
		} catch (error) {
			let errorMessage = 'An unknown error occurred'

			if (error.response) {
				console.error(
					'Error response in Purchase Return Modal:',
					error.response,
				)
				if (error.response.data) {
					console.error(
						'Error response data in Purchase Return Modal:',
						error.response.data,
					)

					try {
						errorMessage =
							error.response.data.PurchaseInvoice.error !== null
								? error.response.data.PurchaseInvoice.error.error.message
								: error.response.data.payments.error.message +
									"!       Sotuv yaratildi lekin to'lov yaratilmadi SAP dan tekshirib oling! "
						errorModalRef.current?.open(errorMessage)
					} catch (parseError) {
						console.error(
							'Parsing error in Purchase Return Modal :',
							parseError,
						)
						errorMessage = 'Failed to parse error response'
					}
				}
			}
		}
		setLoading(false)
	}
	const getInvoices = () => {
		customMainApi
			.get(`Invoices(${docEntry})`, {
				params: {
					$select:
						'DocDate,DocTotal,CardName,CardCode,SalesPersonCode,U_Security,PaidToDate',
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data))
				setDebt(
					get(JSON.parse(res.data), 'DocTotal', 0) -
						get(JSON.parse(res.data), 'PaidToDate', 0),
				)
				getIclouds(get(JSON.parse(res.data), 'U_Security', 0))
			})
	}

	const userFieldsFn = () => {
		customMainApi
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq '@Security'",
				},
			})
			.then((res) => {
				setUserFields2(JSON.parse(res.data).value)
			})
	}
	useEffect(() => {
		if (docEntry) {
			getInvoices()
			const today = moment().format('YYYY-MM-DD')
			setDate(today)
		}
		userFieldsFn()
	}, [docEntry])

	useEffect(() => {
		cashAccounts()
	}, [])

	const getIclouds = (code) => {
		if (code) {
			customMainApi
				.get(`Security('${code}')`, {
					params: {
						$select:
							'Code,Name,U_Whichtelephone,U_Password,U_Status,U_TypeAccount',
					},
					headers: {
						Prefer: 'odata.maxpagesize=100',
					},
				})
				.then((res) => {
					setStatus(JSON.parse(res.data)?.value?.U_Status)
				})
		}
	}

	const cashAccounts = async () => {
		const data = await api(
			`ChartOfAccounts?$select=Code,Name&$filter=startswith(Code, '94') and ExternalCode eq '3'`,
			{
				headers: {
					Prefer: 'odata.maxpagesize=10000',
				},
			},
		).then((res) => {
			return JSON.parse(res.data).value
		})
		setCashAccountsData(data)
	}

	return (
		<Modal
			isOpen={isOpenModal}
			onRequestClose={() => setIsOpenModal(false)}
			style={customStyles}
			contentLabel="Example Modal"
			ariaHideApp={false}
		>
			<ReportsModalStyle>
				<div className="card">
					<p className="title">Добавить возврат</p>
					<div className="flex flex-col gap-4 mb-10">
						<div className="flex  items-center justify-between gap-5 sm:gap-10 flex-col sm:flex-row">
							<div className="flex flex-col items-start gap-3 w-full">
								<p>Дата</p>
								<input
									type="date"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full sm:w-auto'
									}
									value={date}
									onChange={(v) => setDate(v.target.value)}
								/>
							</div>
							<div className="flex flex-col items-start gap-3 w-full">
								<p>Клиент</p>
								<input
									type="text"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full sm:w-auto'
									}
									value={get(userFields, 'CardName', '')}
									disabled={true}
								/>
							</div>
							<div className="flex flex-col items-start gap-3 w-full">
								<p>Сумма</p>
								<input
									type="text"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
									}
									value={get(userFields, 'DocTotal', '')}
									disabled={true}
								/>
							</div>
						</div>
						<div className="flex justify-between flex-col sm:flex-row gap-5">
							<div className="flex flex-col items-start gap-3 w-full">
								<p>Модель</p>
								<input
									type="text"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
									}
									value={item}
									disabled={true}
								/>
							</div>
							<div className="flex flex-col items-start gap-3 w-full">
								<p>Долг</p>
								<input
									type="text"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
									}
									value={debt}
									disabled={true}
								/>
							</div>
						</div>

						<div className="flex items-center justify-between gap-5 sm:gap-10 flex-col sm:flex-row">
							<div className="flex flex-col items-start gap-3 w-full">
								<p>Цена товара</p>
								<input
									type="number"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
									}
									value={price}
									onChange={(e) => setPrice(e.target.value)}
								/>
							</div>
							<div className="flex flex-col items-start gap-3 w-full">
								<p>Счет</p>
								<select
									value={cashAcc}
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full flex-1'
									}
									onChange={(e) => {
										setCashAcc(e.target.value)
									}}
								>
									<option value=""></option>

									{cashAccountsData.map((item) => {
										return (
											<option key={item.Code} value={item.Code}>
												{item.Name} - {item.Code}
											</option>
										)
									})}
								</select>
							</div>
						</div>
					</div>
					<div className="flex items-center justify-between flex-col sm:flex-row gap-5 w-full">
						<AntButton
							className="bg-red-500 h-10 text-white py-2 px-4 rounded-md w-full sm:w-[100px]"
							onClick={() => {
								onClose()
								setIsOpenModal(false)
							}}
						>
							Нет
						</AntButton>
						<AntButton
							loading={loading}
							className="bg-[#0A4D68] h-10 text-white py-2 px-4 rounded-md w-full sm:w-[100px]"
							onClick={submit}
						>
							Да
						</AntButton>
					</div>
				</div>
			</ReportsModalStyle>
			<SuccessModal
				getRef={(r) => {
					successModalRef.current = r
				}}
			/>

			<ErrorModal getRef={(r) => (errorModalRef.current = r)} />
		</Modal>
	)
}

export default PurchaseReturnsModal
